import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

export default function AppShell({ title, subtitle, badge, children, right }) {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#150733] noise-bg">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#150733]/85 border-b border-pink-500/15">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-10 py-3 sm:py-4 flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 sm:gap-4 min-w-0">
            <img
              src="/veloskin-logo.png"
              alt="Veloskin Agility Club"
              className="h-14 sm:h-16 w-auto shrink-0 drop-shadow-[0_0_18px_rgba(240,21,79,0.35)]"
            />
            <div className="min-w-0 hidden sm:block">
              <div className="text-[10px] text-pink-300/70 uppercase tracking-[0.2em]">{user?.role} portal</div>
              <div className="text-xs text-slate-300 font-medium truncate">Drive More · Earn More · Enjoy More</div>
            </div>
          </div>
          <div className="hidden md:flex items-center gap-4">
            {right}
            <div className="text-right">
              <div className="text-sm text-white font-medium">{user?.name}</div>
              <div className="text-xs text-slate-500 font-mono">{user?.phone}</div>
            </div>
            <Button data-testid="btn-logout" onClick={logout} variant="outline" size="sm" className="rounded-full border-white/15 bg-transparent text-slate-300 hover:bg-white/5 hover:text-white">
              <LogOut className="w-4 h-4 mr-2" strokeWidth={1.5} /> Sign out
            </Button>
          </div>
          <Button data-testid="btn-logout-mobile" onClick={logout} variant="outline" size="icon" className="md:hidden rounded-full border-white/15 bg-transparent shrink-0 h-10 w-10">
            <LogOut className="w-4 h-4" strokeWidth={1.5} />
          </Button>
        </div>
      </header>
      <main className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-10 py-6 sm:py-8 lg:py-12">
        <div className="mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-light text-white tracking-tight">{title}</h1>
          {subtitle && <p className="text-sm sm:text-base text-slate-400 mt-2">{subtitle}</p>}
          {badge && <div className="mt-4">{badge}</div>}
        </div>
        {children}
      </main>
    </div>
  );
}
